/* eslint-disable */
import BASE from '../../../../vue.config.js'
import listado from '../../../assets/js/ScriptListadoGeneral.js'
const $ = require('jquery')
window.$ = $

export default {
  data: () => ({
  
    idPlantel:'',
    nombre: '',
    nombrecontacto: '',
    correo: '',
    tel: '',
    extension:'',
    referencia: '',
    direccion: '',
    validaNombre: '',
    validaDireccion: '',
    validaCorreo:'',
    errorCorreo:false,
    errorNombre:false,
    errorDireccion:false,
    validador: true,
    counterDanger:true,
    contieneImagen: 0,
    urlImagen:'',
  
    // center: { lat: 19.403062800000004, lng: -99.151161 },
    // infoOptions: {
    //   pixelOffset: { width: 0, height: -35 }
    // },
    // markers: [],
    // place: null,
    // zoom: 5,

    isButtonDisabled: false
  }),

  methods: {

    Guardar(){

      if (this.idPlantel == 0){
        this.GuardarPlantel();
      }else{
        this.EditarPlantel();
      }
    },

    ObtenerAcceso(){
    
      fetch(`${BASE.baseUrl}api/ValidaAccesoFormulario`, {
        method: 'GET',
        headers: {
                  'Authorization': sessionStorage.getItem('token'),
                  'pagina':'planteles'
                }
      })
      .then(rs => rs.json())
      .catch(error => console.log('error:', error))
      .then(rs => {

        if(rs.status == 427){
            this.$router.push('/'); 
        }
      });
    },

    EliminarImagen(){
        $('div .img-upload').addClass('removeItem');
        this.contieneImagen = 0;
    },

    GuardarPlantel(){
      var objeto = this.ObtenerValoresObjeto();

      if (JSON.stringify(objeto) !='{}') {
        console.log(JSON.stringify(objeto));
        this.openLoadingButton();
         fetch(`${BASE.baseUrl}api/AgregarPlantel`, {
          method: 'POST',
          body: JSON.stringify(objeto),
          headers: {
            'Authorization': sessionStorage.getItem('token'),
            'pagina': 'planteles',
            'Content-Type': 'application/json'
          }
        })
        .then(rs => rs.json())
        .catch(error => console.log('error:', error))
        .then(rs => {
            this.MostrarMensaje(rs.status);
            setTimeout(()=>this.closeLoadingButton(), 1500);
        });
      }
    },

    EditarPlantel(){
      var objeto = this.ObtenerValoresObjeto();
      this.openLoadingButton();
      fetch(`${BASE.baseUrl}api/EditarPlantel`, {
      method: 'POST',
          headers: {
            'Authorization': sessionStorage.getItem('token'),
            'pagina':'planteles',
            'Content-Type':'application/json'
          },
          body: JSON.stringify(objeto),
      })
      .then(rs => rs.json())
      .catch(error => console.log('error:', error))
      .then(rs => {
        this.MostrarMensaje(rs.status);
        setTimeout(()=>this.closeLoadingButton(), 1500);
      })
    },

    ObtenerPlantel(idPlantel){

      fetch(`${BASE.baseUrl}api/ObtenerPlantel/${idPlantel}`, {
            method: 'GET',
            headers: {
              'Authorization': sessionStorage.getItem('token'),
              'pagina':'planteles'
            }
        })
          .then(rs => rs.json())
          .catch(error => console.log('error:', error))
          .then(rs => {
             if(rs.status == 200){
              this.nombre = rs.result.nombre;
              this.tel = rs.result.telefono;
              this.nombrecontacto = rs.result.contacto;
              this.correo = rs.result.correoElectronico;
              this.extension = rs.result.extension;
              this.referencia = rs.result.referencia;
              this.direccion = rs.result.direccion;
              // this.center.lat = rs.result.latitud;
              // this.center.lng = rs.result.longitud;
              this.urlImagen = BASE.baseUrl + rs.result.urlImagen; 
              if (rs.result.urlImagen != ''){this.contieneImagen = 1;}
              this.direccion = rs.result.direccion;

              // $('input.vs-inputx.vs-input--input.normal').val(rs.result.direccion);
              
              // this.center = { lat: rs.result.latitud, lng: rs.result.longitud };
              
              // let place = {
              //   'geometry':{
              //     location:{
              //       lat:rs.result.latitud,
              //       lng:rs.result.longitud
              //     }
              //   }
              // };
              // this.zoom = 12;
              // this.setPlace(place);
            }
          });
    },

    //OBTENMOS LOS VALORES DEL FORMULARIO (SE USA PARA GUARDA Y EDITAR)
    ObtenerValoresObjeto(){

      this.ValidarValores();

      var objeto = {};
      if (this.validador == true){
         objeto = {
          'idPlantel': this.idPlantel,
          'nombre': this.nombre,
          'contacto': this.nombrecontacto,
          'correoElectronico': this.correo,
          'telefono': this.tel,
          'extension': this.extension,
          // 'direccion': this.idPlantel != 0 ? this.direccion : this.direccion.target.value,
          'direccion':  this.direccion,
          'referencia': this.referencia,
          'latitud': 0, //this.center.lat,
          'longitud': 0, //this.center.lng,
          'urlImagen': $('.img-upload img').attr('src')
        }
      }
      return objeto;
    },
    openLoadingButton(){
      this.isButtonDisabled = true;
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#save-button',
        scale: 0.45
      })
    },
    closeLoadingButton(){
      this.$vs.loading.close('#save-button > .con-vs-loading');
      this.isButtonDisabled = false;
    },

    //MUESTRA EN MENSAJE DE LA RESUESTA
    MostrarMensaje(idResupesta){
      
      switch(idResupesta){
        case 200:
          this.$vs.notify({color:'success',title:'Exitoso',text:'El registro se ha guardado correctamente.'})
          setTimeout(() => this.$router.push('/planteles'), 1000);
          break;
        case 427:
          this.$vs.notify({color:'warning',title:'Alerta',text:'No tiene permisos para esta acción.'})
          break;
        case 429:
          this.$vs.notify({color:'warning',title:'Alerta',text:'Datos incorrectos'})
          break;
        case 500:
          this.$vs.notify({color:'danger',title:'Error',text:'Ha ocurrido un error. Favor de ponerse en contacto con el administrador.'})
          break;
        default:
          this.$vs.notify({color:'warning',title:'Alerta',text:'Favor de ponerse en contacto con el administrador.'})
          break;
      } 
    },

    ValidarValores(){
      if (this.nombre == ''){ 
        this.validador = false;
        this.errorNombre = true;
        this.validaNombre = 'El campo nombre es obligatorio.';
      }
      if (this.direccion == ''){
        this.validador = false;
        this.errorDireccion = true;
        this.validaDireccion = 'El campo dirección es obligatorio.';
      }
      if(!listado.methods.validarEmail(this.correo)){
        this.correo = '';
      }
    },

    validarEmail(){
      let correo = listado.methods.validarEmail(this.correo);
      if (!correo) {
        this.errorCorreo = true;
        this.validaCorreo = 'Correo inválido.';
      }else{
        this.errorCorreo = false;
        this.validaCorreo = '';
      }
    },

    // setPlace(place) {
    //   console.log(place)
    //   this.place = place;
    //   let lat = 19.403062800000004;
    //   let lng = -99.151161;
    //   if(this.place.id == undefined){
    //     lat = this.place.geometry.location.lat;
    //     lng = this.place.geometry.location.lng;
    //   }else{
    //     lat = this.place.geometry.location.lat();
    //     lng = this.place.geometry.location.lng();
    //     this.zoom = 12;
    //   }
    //   if(this.place) {
    //     this.markers = [];
    //     this.markers.push({
    //       position: {
    //         lat: lat,
    //         lng: lng
    //       }
    //     })
    //     this.center = { lat: lat, lng: lng };
    //     this.place = null;
    //   }

    //   // Set adress name
    //   this.direccion = `${place.address_components[0].long_name}, ${place.address_components[1].long_name}, ${place.address_components[2].long_name}`;
    // },
    
    Solonumeros(tipo){

      let tel = listado.methods.Solonumeros(this.tel);
      if (tipo == 1){ if(!tel){this.tel =''}}
      if (tipo == 2){ if(!tel){this.extension =''}}
    }
  },
 
  created() {
      this.idPlantel = this.$route.params.idPlantel;
     if (this.idPlantel !=0){ this.ObtenerPlantel(this.idPlantel);}
  },

  updated(){
    if (this.nombre != ''){
     this.validaNombre = ''; 
     this.validador = true;
     this.errorNombre = false; 
    }
    if (this.direccion != ''){
      this.validaDireccion = '';
      this.errorDireccion = false;
      this.validador = true; 
    }
  },

   mounted(){
    this.ObtenerAcceso();
  }
}
